import { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { clsx } from 'clsx'

export default function Dropdown({ 
  trigger, 
  children, 
  align = 'right',
  className = '',
  width = 'w-56'
}) {
  const alignClasses = {
    left: 'left-0 origin-top-left',
    right: 'right-0 origin-top-right',
  }

  return (
    <Menu as="div" className={clsx('relative inline-block text-left', className)}>
      <Menu.Button as={Fragment}>
        {trigger}
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className={clsx(
          'absolute z-50 mt-2 rounded-xl bg-white dark:bg-gray-900 shadow-theme-lg ring-1 ring-gray-200 dark:ring-gray-800 focus:outline-none divide-y divide-gray-100 dark:divide-gray-800',
          width,
          alignClasses[align]
        )}>
          <div className="py-1">
            {children}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

export function DropdownItem({ children, onClick, icon: Icon, danger = false, className = '', ...props }) {
  return (
    <Menu.Item>
      {({ active }) => (
        <button
          onClick={onClick}
          className={clsx(
            'group flex w-full items-center px-4 py-2.5 text-sm transition-colors',
            danger
              ? 'text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20'
              : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800',
            active && (danger ? 'bg-red-50 dark:bg-red-900/20' : 'bg-gray-50 dark:bg-gray-800'),
            className
          )}
          {...props}
        >
          {Icon && (
            <Icon className={clsx(
              'mr-3 h-5 w-5 flex-shrink-0',
              danger ? 'text-red-400' : 'text-gray-400 dark:text-gray-500'
            )} />
          )}
          {children}
        </button>
      )}
    </Menu.Item>
  )
}

export function DropdownDivider() {
  return <div className="border-t border-gray-200 dark:border-gray-700 my-1" />
}

